import type { FundingApplicationSchemas } from "api-types";

import { ACCOUNTING_THRESHOLD_BY_CURRENCY, RSS_ACCOUNTING_THRESHOLD_BY_CURRENCY } from "../components/constants";
import type { FormattedFundingApplicationScreen } from "../queries/funding-application/queries";
import { UploadDocumentType, type BusinessModelData } from "../types";

import { isEcommerceConnectorSelectedLegacy } from "./connectors";

export const isRssBusinessModel = (businessModel: BusinessModelData) => {
  return businessModel && !["ecommerce_dtc", "wholesale"].includes(businessModel);
};

export const getAccountingThreshold = (businessModel: BusinessModelData) => {
  return isRssBusinessModel(businessModel) ? RSS_ACCOUNTING_THRESHOLD_BY_CURRENCY : ACCOUNTING_THRESHOLD_BY_CURRENCY;
};

export const NOT_LISTED = "not_listed";

/* GA connection only required if no ecommerce or payments connectors selected */
export const isGoogleAnalyticsRequired = (selectedConnectorSlugs: string[]): boolean => {
  return !isEcommerceConnectorSelectedLegacy(selectedConnectorSlugs);
};

export const isDocumentOptional = (
  documentType: UploadDocumentType,
  fundingApplication: FormattedFundingApplicationScreen
) => {
  switch (documentType) {
    case UploadDocumentType.CASH_FLOW_FORECAST:
      return fundingApplication.retailPercentage !== "over_eighty";
    case UploadDocumentType.COMPANY_DEBT_AGREEMENT:
      return true;
    case UploadDocumentType.MANAGEMENT_ACCOUNTS:
    case UploadDocumentType.PROFIT_AND_LOSS:
    case UploadDocumentType.BALANCE_SHEET:
      return false;
    case UploadDocumentType.POOL_BANCARIO:
      return true;
    case UploadDocumentType.SUSA:
      return false;
  }
};

export const isDocumentOptionalNext = (
  documentType: FundingApplicationSchemas.DocumentType,
  fundingApplicationStages: FundingApplicationSchemas.CustomerFundingApplicationStagesScreen
): boolean => {
  if (documentType === "profit-and-loss" || documentType === "balance-sheet") {
    return !!fundingApplicationStages.accounting?.canOptOut;
  }
  const stage = fundingApplicationStages?.documents?.find((stage) => stage.documentType === documentType);
  return !!stage?.canOptOut;
};
